// Hooks
import { useParams } from 'react-router';
import React, { useEffect, useState, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useRecordTypes } from '../../../../views/RecordType/hooks/useRecordTypes';
import { useHistory } from 'react-router-dom';
import { ErrorMessage } from '@hookform/error-message';

// Styles

import { toast } from 'react-toastify';

import {
  Container,
  Row,
  Card,
  Button,
  Form,
  Col,
  Input,
  CardHeader,
  CardBody
} from 'reactstrap';

// Componentes
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ReactButton from 'components/Buttons/ReactButton';
import FlexSelect from 'components/Inputs/FlexSelect';
import ModalAddListOption from '../components/ModalAddListOption';
import { ScreenPrompt } from 'components/ScreenPrompt';
import ListItemsTable from './table';

// Services
import LostReasonService from '../services/LostReasonService';

const errorFormMessage = (message) => <p style={{ color: 'red' }}>{message}</p>;

const LostReasonConfigForm = () => {
  const { id } = useParams();
  const [entityName, setEntityName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [listItems, setListItems] = useState([]);
  const [isOptionEdition, setIsOptionEdition] = useState(false);
  const [dataOptionToEdit, setDataOptionToEdit] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const { recordTypes } = useRecordTypes(entityName);

  const {
    control,
    handleSubmit,
    errors,
    setValue,
    watch,
    clearErrors,
    formState
  } = useForm();
  const { isDirty } = formState;

  const history = useHistory();

  useEffect(() => {
    if (id) {
      try {
        setIsUpdate(true);

        LostReasonService.getById(id)
          .then((response) => {
            const data = response.data.data.data[0];
            const recordTypeIds = data.recordTypesConfig
              .filter((item) => item?.isActive)
              .map((item) => item.recordTypeId);

            setValue('description', data.description);
            setValue('entity', data.entity);
            setIsActive(data?.isActive);
            setValue('recordTypeIds', recordTypeIds);
            setListItems(
              data.options?.map((option) => ({
                name: option.value,
                recordTypeIds: option.recordTypeIds
              })) || []
            );
          })
          .catch(() => {
            toast.error('Ocorreu um erro ao buscar os dados do campo');
          });
      } catch (error) {
        toast.error('Ocorreu um erro ao buscar os dados do campo');
      }
    }
  }, [id, setValue]);

  useEffect(() => {
    if (watch('entity') === 'LEAD') {
      setEntityName('LEAD');
    } else if (watch('entity') === 'OPPORTUNITY') {
      setEntityName('OPPORTUNITY');
    }
  }, [watch('entity')]);

  const itemAlreadyExists = (list, item) => {
    return list.map((option) => option.name).includes(item.name);
  };

  const addListItem = (new_item) => {
    if (itemAlreadyExists(listItems, new_item)) {
      return toast.warning('Uma opção como mesmo nome já foi criada!', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
    setListItems([...listItems, new_item]);
    clearErrors('list_options');
  };

  const handleUpdateItem = useCallback((name, { recordTypeIds }) => {
    setListItems((currentItems) => {
      currentItems.forEach((item) => {
        if (item.name === name) {
          item.recordTypeIds = recordTypeIds;
        } else {
          item.name = name;
          item.recordTypeIds = recordTypeIds;
        }
      });

      return currentItems;
    });
  }, []);

  const removelistItem = (item) => {
    const remain_items = listItems.filter((el) => el !== item);
    setListItems(remain_items);
  };

  const handleOpenModalToEditOption = (optionData) => {
    setIsOptionEdition(true);
    setDataOptionToEdit(optionData);
    setIsModalOpen(true);
  };

  const onSubmit = async (data) => {
    try {
      const dataToSend = {
        name: data.name,
        description: data.description,
        entity: data.entity,
        isActive: isActive
      };

      const recordTypesConfig = !data.recordTypeIds
        ? []
        : data.recordTypeIds.map((id) => ({
            recordTypeId: id,
            isRequired: data[`isRequired-${id}`] || false,
            isNotEditable: data[`isNotEditable-${id}`] || false,
            isOnlyToShowOnEdit: data[`isOnlyToShowOnEdit-${id}`] || false,
            isActive: true,
            defaultValue: data[`defaultValue-${id}`] || ''
          }));

      dataToSend.recordTypesConfig = recordTypesConfig;

      const optionsDTO = listItems.map((item) => {
        let dataFromReturn = {
          value: item.name,
          recordTypeIds: item.recordTypeIds
        };

        return dataFromReturn;
      });
      dataToSend.options = optionsDTO;

      isUpdate
        ? await LostReasonService.update(id, dataToSend)
        : await LostReasonService.create(dataToSend);

      toast.success(
        `Motivo de perda ${isUpdate ? 'atualizado' : 'criado'} com sucesso`
      );
      history.push('/admin/crm/lostReason');
    } catch (error) {
      console.error(error);
      const errorMessage = error.response?.data?.message;
      toast.error(errorMessage || 'Erro ao realizar operação');
    }
  };

  const handleCheckboxActiveChange = (e) => {
    const checked = e.target.checked;
    setIsActive(checked);
  };

  const cancelAction = () => {
    history.push('/admin/crm/lostReason');
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/crm/lostReason"
        buttonTitle="Voltar para a pagina de configuração de Motivo de Perda"
      />
      <ModalAddListOption
        isOpenModal={isModalOpen}
        onModalToggle={setIsModalOpen}
        setterFunction={addListItem}
        recordTypes={recordTypes}
        isOptionEdition={isOptionEdition}
        dataOptionToEdit={dataOptionToEdit}
        handleUpdateItem={handleUpdateItem}
        entityName={entityName}
      />
      <Container className="mt--6" fluid>
        <Row className="mb-3">
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Motivos De Perda</h3>
                </CardHeader>
                <CardBody>
                  <Form
                    className="needs-validation"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <ScreenPrompt
                      when={isDirty && !formState.isSubmitting}
                      message={`Está certo de que deseja sair? Terá que preencher os dados novamente quando retornar`}
                    />
                    <Row>
                      <Col md="6">
                        <label className="form-control-label">Descrição</label>
                        <Controller
                          as={Input}
                          control={control}
                          name="description"
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="description"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>

                      <Col md="6">
                        <label className="form-control-label mr-3">Ativo</label>
                        <Input
                          type="checkbox"
                          checked={isActive}
                          onChange={handleCheckboxActiveChange}
                          style={{
                            display: 'flex',
                            marginTop: '15px',
                            marginLeft: '5px'
                          }}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="isActive"
                          render={({ message }) => (
                            <span className="text-danger">{message}</span>
                          )}
                        />
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col md="6">
                        <label className="form-control-label">Tipo*</label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              isClearable={true}
                              dataOptions={[
                                { label: 'LEAD', value: 'LEAD' },
                                { label: 'OPORTUNIDADE', value: 'OPPORTUNITY' }
                              ]}
                              isMulti={false}
                              closeMenuOnSelect={true}
                              value={props.value}
                              valueController={setValue}
                              fieldName="entity"
                              labelName="label"
                              valueName="value"
                            />
                          )}
                          control={control}
                          name="entity"
                          rules={{
                            required: 'Campo obrigatório'
                          }}
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="entity"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>

                      <Col>
                        <label className="form-control-label">
                          Tipos de registro*
                        </label>
                        <Controller
                          render={(props) => (
                            <FlexSelect
                              dataOptions={recordTypes || []}
                              isMulti={true}
                              value={props.value}
                              valueController={setValue}
                              fieldName="recordTypeIds"
                              labelName="name"
                              valueName="id"
                              isClearable={true}
                              isDisabled={entityName === ''}
                            />
                          )}
                          control={control}
                          name="recordTypeIds"
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="recordTypeIds"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                    </Row>

                    <>
                      <Row className="mt-3 mb-3">
                        <Col md="5">
                          <Button
                            color="success"
                            type="button"
                            onClick={() => {
                              setDataOptionToEdit(null);
                              setIsOptionEdition(false);
                              setIsModalOpen(true);
                            }}
                          >
                            Adicionar opção
                          </Button>
                          <ErrorMessage
                            errors={errors}
                            name="list_options"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>
                    </>

                    <ListItemsTable
                      listItems={listItems}
                      recordTypes={recordTypes}
                      handleOpenModalToEditOption={handleOpenModalToEditOption}
                      removeListItem={removelistItem}
                    />

                    <hr />
                    <ReactButton btnColor="confirmation" type="submit">
                      Salvar
                    </ReactButton>
                    <ReactButton
                      btnColor="cancelation"
                      onClick={() => {
                        return cancelAction();
                      }}
                    >
                      Cancelar
                    </ReactButton>
                  </Form>
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default LostReasonConfigForm;
